import socialMedialData from './socialMediaData';

export default socialMedialData;
